import React from 'react'
import { Form, Input, Button } from 'antd'
import { func } from 'prop-types'

import { useCreateExpert } from '@graphql/mutations'

function ManageExpertForm({ afterSubmit }) {
  const [form] = Form.useForm()
  const [createExpert, { loading }] = useCreateExpert()

  const onFinish = data => {
    createExpert({
      variables: {
        data: { ...data },
      },
      refetchQueries: ['GetExpertsQuery'],
    }).then(callback => afterSubmit(callback), form.resetFields())
  }

  return (
    <Form onFinish={onFinish} form={form}>
      <Form.Item
        name="name"
        rules={[
          {
            required: true,
            message: `Campo obrigatório`,
          },
        ]}
        hasFeedback
      >
        <Input placeholder="Nome do técnico" size="large" autoFocus />
      </Form.Item>

      <Button
        type="primary"
        htmlType="submit"
        size="large"
        disabled={loading}
        block
      >
        Criar técnico
      </Button>
    </Form>
  )
}

ManageExpertForm.propTypes = {
  afterSubmit: func,
}

ManageExpertForm.defaultProps = {
  afterSubmit: null,
}

export default ManageExpertForm
